/**
 * engagementreducer.js
 * Created by calhosh on 8/27/2020.
 */
import {get as _get} from 'lodash';
import {HttpStatusCodes} from '../../util/uiconstants';
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import {currentResource} from '../../util/utils';
import normalizeEngagements from './normalizeEngagements';

export function engagementReducer(state = initialState.engagement, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT: {
			return action.response;
		}
		default:
			return state;
	}
}

export function engagementsSummaryReducer(state = initialState.engagementsSummary, action) {
	switch (action.type) {
		case types.GET_CLIENT_ENGAGEMENTS: {
			let engagements = action.response;
			if (action.payload && action.payload.canvasEngagements) {
				let canvasEngagementIds = new Set(engagements.map(({canvasEngagementId}) => canvasEngagementId));
				engagements = [
					...engagements,
					...action.payload.canvasEngagements.filter(
						({canvasEngagementId}) => !canvasEngagementIds.has(canvasEngagementId) && canvasEngagementId > 0
					)
				];
			}
			engagements = _.uniqBy(engagements, function(e) {
				return e.canvasEngagementId;
			});
			return {
				...state,
				clientEngagements: engagements
			};
		}
		case types.CREATE_PROJECT:
		case types.GET_PROJECT_TO_EDIT: {
			return {
				...state,
				clientEngagements: initialState.engagementsSummary.clientEngagements
			};

			return state;
		}
		case types.UPDATE_PROJECT: {
			if (action.stepUpdated === 1) {
				return {
					...state,
					clientEngagements: initialState.engagementsSummary.clientEngagements
				};
			}

			return state;
		}
		case types.CLEAR_CLIENT_ENGAGEMENTS: {
			if (action.payload && action.payload.clients) {
				return {
					clientEngagements: undefined
				};
			}
			return {
				clientEngagements: undefined
			};
		}
		default:
			return state;
	}
}

export function engagementReducerAllUserEngagements(state = initialState.allUserEngagements, action) {
	switch (action.type) {
		case types.GET_ALL_USER_ENGAGEMENTS: {
			return action.response;
		}
		default:
			return state;
	}
}

export function engagementMetaDataReducer(state = initialState.engagementMetaData, action) {
	switch (action.type) {
		case types.LOAD_ENGAGEMENTMETADATA:
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return normalizeEngagements(data, action.userType);
			}
			return [];
		default:
			return state;
	}
}

export function engagementUsersWithRoles(state = initialState.engagementUsersWithRoles, action) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_USERS_WITHROLES: {
			return action.response;
		}
		default:
			return state;
	}
}

export function countryStatusReducer(state = initialState.countryStatus, action) {
	switch (action.type) {
		case types.GET_COUNTRY_STATUS: {
			return action.response;
		}
		default:
			return state;
	}
}

export function engagementUserRolesReducer(state = initialState.roles, action) {
	switch (action.type) {
		case types.GET_ALL_ENGAGEMENT_USER_ROLES:
			return getLocalizedRoles(action);
		default:
			return state;
	}
}

export function rbacUserRolesReducer(state = initialState.rbacRoles, action) {
	switch (action.type) {
		case types.GET_ALL_RBAC_USER_ROLES:
			return action.response;
		default:
			return state;
	}
}

function getLocalizedRoles(action) {
	let engagementUserRoles = [];

	let localizedEngagementUserRoles = currentResource.roleForMember;
	_.each(action.response, function(apiRole) {
		let localRole = localizedEngagementUserRoles.find((x) => x.id === apiRole.id);
		let finalName = localRole ? localRole.role : apiRole.name;
		engagementUserRoles.push({
			id: apiRole.id,
			name: finalName
		});
	});

	return engagementUserRoles;
}

export function workspaceReducer(state = initialState.workspaceMetaData, action) {
	switch (action.type) {
		case types.GET_WORKSPACE_METADATA: {
			return action.response;
		}
		default:
			return state;
	}
}